import KundenAdresseStorage from "../storage/kundenAdresse-storage";
import { SET_ADRESS_LIST } from "../actions/types/kundenAdresse-types";

export default function reducer(state = KundenAdresseStorage, action) {
  switch (action.type) {
    case SET_ADRESS_LIST: {
      let newState = { ...state };
      newState.setAdressList(action.payload);
      return newState;
    }
    default:
      return state;
  }
}
